(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/[\s-]+/g, '-')
      .slice(0, 60) || 'section';
  }

  function stickyOffset(root) {
    var top = parseFloat(getComputedStyle(root).getPropertyValue('--cpp-top')) || 0;
    var aside = root.querySelector('[data-cpp-aside]');
    var asideStuck = aside && getComputedStyle(aside).position === 'sticky';
    return top + (asideStuck ? aside.offsetHeight : 0) + 24;
  }

  function init(root) {
    var content = root.querySelector('[data-cpp-content]');
    var aside = root.querySelector('[data-cpp-aside]');
    var nav = root.querySelector('.cpp__nav');
    var list = root.querySelector('[data-cpp-list]');
    var toggle = root.querySelector('[data-cpp-toggle]');
    var current = root.querySelector('[data-cpp-current]');
    if (!content || !list) return;

    var levels = root.getAttribute('data-heading-levels') || 'auto';
    var selector = levels === 'auto' ? 'h2' : levels;
    var headings = Array.prototype.slice.call(content.querySelectorAll(selector));
    if (levels === 'auto' && headings.length < 2) {
      headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
    }
    headings = headings.filter(function (h) { return h.textContent.trim(); });
    if (headings.length < 2) return;

    var used = {};
    var links = headings.map(function (h) {
      var label = h.textContent.replace(/\s+/g, ' ').trim();
      if (!h.id) {
        var id = slugify(label);
        var n = 2;
        while (used[id] || document.getElementById(id)) id = slugify(label) + '-' + n++;
        h.id = id;
      }
      used[h.id] = true;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'cpp__link' + (h.tagName === 'H3' && selector !== 'h3' && headings.some(function (x) { return x.tagName === 'H2'; }) ? ' cpp__link--sub' : '');
      a.textContent = label;
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });

    aside.hidden = false;
    aside.parentElement.classList.add('has-nav');

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    var activeIndex = -1;
    var locked = false;
    var lockTimer;

    // Hold the clicked link active until the smooth scroll settles
    function lock() {
      locked = true;
      clearTimeout(lockTimer);
      lockTimer = setTimeout(unlock, 'onscrollend' in window ? 3000 : 1200);
    }
    function unlock() {
      clearTimeout(lockTimer);
      locked = false;
    }

    function setActive(i) {
      if (i === activeIndex) return;
      if (activeIndex > -1) {
        links[activeIndex].classList.remove('is-active');
        links[activeIndex].removeAttribute('aria-current');
      }
      activeIndex = i;
      if (i < 0) {
        current.textContent = '';
        return;
      }
      var link = links[i];
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'true');
      current.textContent = link.textContent;

      // link.offsetParent is the scroller itself: the sticky nav on desktop, the absolute list on mobile
      var scroller = link.offsetParent;
      if (scroller && scroller.scrollHeight > scroller.clientHeight) {
        var linkTop = link.offsetTop;
        if (linkTop < scroller.scrollTop || linkTop + link.offsetHeight > scroller.scrollTop + scroller.clientHeight) {
          scroller.scrollTop = linkTop - scroller.clientHeight / 2;
        }
      }
    }

    function update() {
      if (locked) return;
      var line = stickyOffset(root) + 8;
      var i = -1;
      for (var k = 0; k < headings.length; k++) {
        if (headings[k].getBoundingClientRect().top <= line) i = k;
        else break;
      }
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
        var lastTop = headings[headings.length - 1].getBoundingClientRect().top;
        if (lastTop < window.innerHeight) i = headings.length - 1;
      }
      setActive(i);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = headings[i];
        setOpen(false);
        var y = target.getBoundingClientRect().top + window.scrollY - stickyOffset(root) + 8;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
        setActive(i);
        lock();
        if (history.replaceState) history.replaceState(null, '', '#' + target.id);
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scrollend', function () {
      if (!locked) return;
      unlock();
      update();
    });
    window.addEventListener('resize', onScroll);

    if (location.hash) {
      var fromHash = headings.findIndex(function (h) { return '#' + h.id === decodeURIComponent(location.hash); });
      if (fromHash > -1) {
        setTimeout(function () { links[fromHash].click(); }, 50);
        return;
      }
    }
    update();
  }

  function boot() {
    document.querySelectorAll('[data-cpp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
